let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ePQ86")).then(() => parcelRequire('eLwjA'));